<template>
  <dx-button
    class="theme-button"
    styling-mode="text"
    :icon="theme.theme === 'dark' ? 'sun' : 'moon'"
    @click="onClickButton"
  />
</template>

<script setup>
import { DxButton } from 'devextreme-vue/button';
import { useThemeStore } from '@/stores/theme';
const theme = useThemeStore();

function onClickButton() {
  theme.toggleTheme();
}
</script>
